import React from "react";
import { GetIbanResponse } from "../../../models/iban.model";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

interface Props {
  getibanResponse: GetIbanResponse;
}
const AssignBranchToIbanHeader = ({ getibanResponse }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <Grid
        container
        boxShadow={"0px 1px 1px rgba(0,0,0,0.16)"}
        flexDirection={"column"}
        height={"100%"}
        padding={2}
      >
        <Grid
          item
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          flexDirection={isMobile ? "column" : "row"}
        >
          <Grid item sx={{ display: "flex", alignItems: "center" }}>
            {getibanResponse?.prefix ? (
              <Box
                sx={{
                  backgroundColor: "#fff",
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  border: "1px solid #DAE0E4",
                  boxShadow: "0px 2px 4px rgba(0,0,0,0.6)",
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: "15px",
                }}
              >
                <img
                  src={`/images/Banks/${getibanResponse?.prefix}.png`}
                  alt={getibanResponse?.bankName}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>
            ) : (
              <AccountCircleIcon
                sx={{
                  color: "#9AAFC4",
                  fontSize: "60px !important",
                  marginLeft: "15px",
                }}
              />
            )}

            <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
              <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
                {getibanResponse?.bankName}
              </b>
            </Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
              <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
                نام صاحب حساب: {getibanResponse?.owner}
              </b>
            </Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
              <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
                شماره شبا: {getibanResponse?.iban}
              </b>
            </Typography>
          </Grid>
          <Grid item></Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AssignBranchToIbanHeader;
